import { Modal } from 'ant-design-vue';

const DefaultProp = {
  text: '成功',
  confirmText: '确定',
  showCancelBtn: true,
};

export const showModal2 = (
    prop,
    width = '408px',
    autoClose = true,
    basicProps = {},
  ) => {
    // if (document.documentElement.clientWidth < (screenMap.get(sizeEnum.LG) ?? 0)) {
    //   width = '94%';
    // }
    prop.showCancelBtn == undefined && (prop.showCancelBtn = DefaultProp.showCancelBtn);
    const modal = Modal.confirm({
      class: 'hidden-button confirm-modals',
      width,
      title: prop.title,
      content: () => {
        return (
          <div class="custom-modal-content">
            <div>{prop.content || DefaultProp.text}</div>
            <div class={!prop.showCancelBtn ? 'flex-center' : 'flex-center'} style="margin-top: 30px">
              {prop.showCancelBtn && (
                <div
                  class="cancel-btn hand"
                  onClick={() => {
                    prop.cancelFn && prop.cancelFn();
                    modal.destroy();
                  }}
                >
                  {prop.cancelText || '取消'}
                </div>
              )}
              {!prop.hideConfirmBtn && (
                <div
                  class="confirm-btn hand"
                  onClick={() => {
                    if (autoClose) {
                      modal.destroy();
                    }
                    prop.confirmFn && prop.confirmFn();
                  }}
                >
                  {prop.confirmText || DefaultProp.confirmText}
                </div>
              )}
            </div>
          </div>
        );
      },
      icon: '',
      closable: true,
      maskClosable: true,
      ...basicProps,
    });
    return modal;
  };